module.exports = __webpack_public_path__ + "img/ic-analysis-lineplot1.d1686398.svg";